export interface ClientConfig {
  /** WebRTC endpoint: publishing, and the director's live monitor. */
  mediaBase: string;
  /** HLS endpoint: the public output, held behind the live edge. */
  hlsBase: string;
  /** How far back the public output is held, in ms. */
  delayMs: number;
  /**
   * Where a human reads the standard. Always present: the node falls back to
   * its own `/api/standard` rather than to a hostname that may not exist.
   */
  standardUrl: string;
  /** Where a person disagrees with a ruling. Empty means there is no route yet. */
  appealContact: string;
}

let cached: ClientConfig | null = null;

export async function loadConfig(): Promise<ClientConfig> {
  if (cached) return cached;
  const res = await fetch('/api/config');
  cached = (await res.json()) as ClientConfig;
  return cached;
}
